<script lang="ts">
    import { PRODUCT_VARIANT_DEFAULT_TITLE } from "@/constants";

    import Icon from "@components/Icon.svelte";
    import Image from "@components/Image/Image.svelte";
    import Money from "@components/Money.svelte";
    import UnavailableProductContainer from "@components/UnavailableProductContainer.svelte";

    import NoProductIcon from "../icons/NoProductIcon.svelte";

    export let productId: number;
    export let token: string;
</script>

<UnavailableProductContainer
    {productId}
    {token}
    let:productInfo
    on:productReady
>
    {@const product = productInfo.product}
    {#if product}
        <div class="gw-rv-product">
            <div class="gw-rv-product__inner">
                <div class="gw-rv-product__info">
                    <div class="gw-rv-product__left">
                        {#if product?.imageUrl}
                            <Image
                                src={product.imageUrl + "&width=128"}
                                alt={product.title || ""}
                                blur
                                imgClassName="gw-rv-product__image"
                                objectFit="cover"
                                on:imageLoaded
                            />
                        {:else}
                            <Icon width="60" height="60" viewBox="0 0 60 60">
                                <NoProductIcon />
                            </Icon>
                        {/if}
                    </div>
                    <div class="gw-rv-product__right">
                        <h4 class="gw-rv-product__title">
                            {product.title}
                        </h4>

                        {#if product?.variants?.[0].title !== PRODUCT_VARIANT_DEFAULT_TITLE}
                            <h5 class="gw-rv-product__sub-title">
                                {product?.variants?.[0].title}
                            </h5>
                        {/if}

                        {#if product?.price}
                            <span class="gw-rv-product__price">
                                <Money amount={product.price} />
                            </span>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    {/if}
</UnavailableProductContainer>

<style lang="postcss">
    .gw-rv-product {
        background-color: inherit;

        &__inner {
            border-top: 1px solid #f0f0f0;
            padding: 1.25em 0 0;
            display: flex;
            justify-content: space-between;

            @media all and (max-width: 600px) {
                padding: 1em 0;
            }
        }

        &__info {
            width: 100%;
            display: flex;
            justify-content: space-between;
            gap: 1em;
            align-items: center;
        }

        &__left {
            max-width: 64px;
            min-width: 60px;
            height: 60px;
        }

        &__right {
            flex: 1;
        }

        &__title {
            margin: 0;
            font-size: 0.875em;
            line-height: normal;
            font-weight: 600;
        }

        &__sub-title {
            margin: 2px 0 0;
            font-size: 0.75em;
            line-height: normal;
            font-weight: 400;
        }

        &__price {
            margin-top: 0.5em;
            display: inline-block;
            font-size: 0.75em;
        }
    }

    :global(.gw-rv-product__image) {
        border-radius: 3px;
        box-sizing: border-box;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    }
</style>
